import { useTranslation } from 'react-i18next';

/**
 * Detects whether cookies are enabled by writing and reading a test cookie.
 * Returns true if cookies are functional, false if blocked.
 */
function areCookiesEnabled(): boolean {
  try {
    const testKey = '__cookie_test__';
    document.cookie = `${testKey}=1; path=/; SameSite=Lax`;
    const enabled = document.cookie.includes(testKey);
    // Clean up test cookie
    document.cookie = `${testKey}=; path=/; Max-Age=0; SameSite=Lax`;
    return enabled;
  } catch {
    return false;
  }
}

/**
 * Renders a full-page banner when cookies are disabled in the browser.
 * Should be rendered instead of the main app tree when cookies are unavailable.
 */
export function CookiesRequired() {
  const { t } = useTranslation('cookies');

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md rounded-lg border border-amber-200 bg-amber-50 p-8 text-center shadow-sm">
        <div className="mb-4 text-4xl">🍪</div>
        <h1 className="mb-3 text-xl font-semibold text-amber-900">{t('cookiesRequired.title')}</h1>
        <p className="mb-6 text-sm text-amber-800">{t('cookiesRequired.message')}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-amber-600 px-4 py-2 text-sm font-medium text-white hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
        >
          {t('cookiesRequired.reload')}
        </button>
      </div>
    </div>
  );
}

export { areCookiesEnabled };
